import { observer } from 'mobx-react-lite'
import { Trans, useTranslation } from 'next-i18next'
import useLangPrefix from '@/hooks/useLangPrefix'
import { useAdapter } from '@/components/Adapter'
import { useStore } from '@/store/index'
import { Collapse } from '@gate/gui'
import { PriceFaqsStyled, PriceFaqsTitleStyled } from './style'
import { TECHNICAL_ANALYSIS_URL } from '@/constants/index'
import { useMemo } from 'react'

const PriceFaqs = () => {
  const { langPrefix } = useLangPrefix()
  const { coinCount } = useStore().baseStore

  const { t } = useTranslation()

  const { isH5 } = useAdapter()

  const list = useMemo(() => {
    return [
      {
        title: t(`P.TSC`),
        context: [t(`P.WTGFB`)],
      },
      {
        title: t(`P.FATAH`),
        context: [t(`P.AccuratePrice`, { quantity: coinCount }), t(`P.OTP`, { quantity: coinCount })],
      },
      {
        title: t(`P.HDC`),
        context: [t(`P.UsingAFormula`), t(`P.AreGenerally`)],
      },
      {
        title: t(`P.WATCT`),
        context: [
          <Trans
            key={'0'}
            i18nKey={`P.POL`}
            values={{ quantity: coinCount }}
            components={[
              <a
                key={'0'}
                href={`${langPrefix}/price/bitcoin-btc`}
                target="_blank"
                style={{ color: 'var(--color-brand-1)' }}
              />,
              <a
                key={'1'}
                href={`${langPrefix}/price/ethereum-eth`}
                target="_blank"
                style={{ color: 'var(--color-brand-1)' }}
              />,
            ]}
          ></Trans>,
        ],
      },
      {
        title: t(`P.WAAC`),
        context: [
          t(`P.SurgesFurther`),
          <Trans
            key={'0'}
            i18nKey={`P.ToDetermine`}
            components={[
              <a
                key={'0'}
                href={`${TECHNICAL_ANALYSIS_URL(langPrefix)}`}
                target="_blank"
                style={{ color: 'var(--color-brand-1)' }}
              />,
            ]}
          ></Trans>,
        ],
      },
      {
        title: t(`P.WAA`),
        context: [t(`P.ToBitcoinWith`)],
      },
      {
        title: t(`P.WhatAreETF`),
        context: [t(`P.IJTSA`)],
      },
      {
        title: t(`P.WTBCT`),
        context: [t(`P.AOAPF`)],
      },
      {
        title: t(`P.SCT`),
        context: [
          <Trans
            key={'0'}
            i18nKey={`P.FactorsMaking`}
            components={[
              <a
                key={'0'}
                href={`${langPrefix}/learn/articles/How-to-Do-Your-Own-Research-DYOR/35`}
                target="_blank"
                style={{ color: 'var(--color-brand-1)' }}
              />,
            ]}
          ></Trans>,
        ],
      },
    ]
  }, [coinCount, langPrefix, t])

  return (
    <PriceFaqsStyled w={'100%'} direction="column">
      <PriceFaqsTitleStyled>{t('P.CHTMA')}</PriceFaqsTitleStyled>
      {list.map((item, index) => (
        <Collapse
          size={'md'}
          isH5MappingAppStyle={isH5}
          w={'100%'}
          key={'price-collapse-' + index}
          title={item.title}
          titleComponent={'h3'}
        >
          {item.context}
        </Collapse>
      ))}
    </PriceFaqsStyled>
  )
}

export default observer(PriceFaqs)
